import {createReducer} from "typesafe-actions";
import {SELECT_CATEGORIES_MENU} from "../actions";

export const categoriesIDReducer = createReducer<number | 'rating' | 'home' | null>('home')
    .handleAction(SELECT_CATEGORIES_MENU, (state, action) => action.payload);